// Shared contract status list — value + dot colour — so the contracts list
// filter, the detail page's badge/select, and any future caller draw from
// one map instead of duplicating the four statuses (patterns §15).
export const CONTRACT_STATUS_OPTIONS = [
  { value: 'draft', dot: 'bg-muted-foreground/60' },
  { value: 'open', dot: 'bg-emerald-500' },
  { value: 'in_progress', dot: 'bg-blue-500' },
  { value: 'closed', dot: 'bg-muted-foreground/60' },
] as const

export type ContractStatusValue = typeof CONTRACT_STATUS_OPTIONS[number]['value']

export function contractStatusDot(status: string): string {
  return CONTRACT_STATUS_OPTIONS.find((opt) => opt.value === status)?.dot || 'bg-muted-foreground/60'
}
